export const environment = {
    production: true,
    loginCookie: "loginCookie",
    instanceCookie: "instanceCookie",
    userRights: "userRightsCookie",
    logout_url: ".io-netgate.net/auth/logout",
    dashboard_url: ".io-netgate.net/dashboard",
    API_URL:"https://prs57.api.io-netgate.net/api/v1/",
    // API_URL:"http://testrahul.io-netgate.net:7500/api/v1/",
    NGT_18_URL:"https://api.netgate.io-procurement.com/server/?method=",
    NETGATE_URL: 'https://portal.netgate.io-procurement.com/',
    WEB_URL: 'https://p2p.io-netgate.net/',
    PASSWORD_LENGTH: 8,
    SUB_DOMAIN:".io-netgate.net",
    SESSION_EXPIRY:30000*60*30,
    version: '0.0.18',
    languageCookie:"languageCookie",
    NGT18_URL_INFO: "",
    color: 'colorChangeTest',
    ARCHIVE_URL:'https://archiv.io-netgate.net/',
    INVOICE_URL:'https://dfh56.api.io-netgate.net/api/v1/'
  };
